export enum OmistusPohja {
  YKSITYINEN = 'Yksityinen omistus',
  PORSSI = 'Pörssiyritys',
}
